/** Canais, onboarding e o resultado da conexão (QR/oauth/token/pairing). */
import { z } from "zod";
import { channelStatus, channelType } from "../enums.js";
import { channelCapabilities } from "../capabilities.js";
import { uuid } from "./common.js";

/* ---------- Canais ---------- */
export const channel = z.object({
  id: uuid,
  name: z.string(),
  type: channelType,
  status: channelStatus,
  e164: z.string().nullable(),
  capabilities: channelCapabilities,
  /** Presente apenas enquanto o canal precisa de QR (capabilities.qr). */
  qr: z.string().nullable().optional(),
  createdAt: z.string(),
});
export type Channel = z.infer<typeof channel>;

export const createChannelInput = z.object({
  name: z.string().min(1).max(80),
  type: channelType.default("whatsapp_waha"),
});
export type CreateChannelInput = z.infer<typeof createChannelInput>;

/** Importacao do historico do canal. `days: null` = tudo que o provider tiver. */
export const importHistoryInput = z.object({
  days: z.number().int().positive().max(3650).nullable().default(30),
});
export type ImportHistoryInput = z.infer<typeof importHistoryInput>;
export const importHistoryResult = z.object({
  chats: z.number().int().nonnegative(),
  messages: z.number().int().nonnegative(),
});
export type ImportHistoryResult = z.infer<typeof importHistoryResult>;

/* ---------- Conexão de canal ---------- */
export const connectResult = z.discriminatedUnion("kind", [
  z.object({
    kind: z.literal("qr"),
    qrImageUrl: z.string().nullable(),
    pairingCode: z.string().nullable().optional(),
    expiresAt: z.string().optional(),
    status: channelStatus,
  }),
  z.object({ kind: z.literal("oauth"), oauthUrl: z.string(), expiresAt: z.string().optional(), status: channelStatus }),
  z.object({ kind: z.literal("token"), token: z.string(), expiresAt: z.string().optional(), status: channelStatus }),
  z.object({ kind: z.literal("pairing_code"), code: z.string(), expiresAt: z.string().optional(), status: channelStatus }),
]);
export type ConnectResult = z.infer<typeof connectResult>;
